document.addEventListener('DOMContentLoaded', function() {
    // 1. Hide watermark container
    const watermarkContainer = document.querySelector(
        '[id*="eu_widerruf_button_form_inline"] > div:nth-child(2)'
    );
    if (watermarkContainer) {
        watermarkContainer.style.display = 'none';
    }

    // 2. Set unique product form IDs
    const forms = document.querySelectorAll('.product-item__product-form');
    forms.forEach((form, index) => {
        const productId = form.querySelector('input[name="product-id"]')?.value || index;
        const uniqueId = `product_form_${productId}_${index + 1}`;
        form.id = uniqueId;
    });

    // 3. Update Instagram ARIA label
    const instagramLink = document.querySelector(
        '.instafeed-bottom-link-wrapper a[aria-label="Visit our Instagram profile"]'
    );
    if (instagramLink) {
        instagramLink.setAttribute(
            'aria-label',
            '@xalorahaircare Instagram profile'
        );
    }

    // 4. Page-specific styles for professionals page
    const currentPath = window.location.pathname.replace(/\/$/, "");
    if (currentPath === "/pages/professionals") {
        const style = document.createElement("style");
        style.textContent = `
            .rich-text ol,
            .rich-text ul {
                list-style-position: inside;
                padding-left: 0;
            }
        `;
        document.head.appendChild(style);
    }
});